export default __webpack_public_path__ + "static/media/duo-chating.15c8ab38.svg";